import * as R from 'ramda'
import { Base64 } from 'js-base64'
import qs from 'qs'

import {
  generateFeedbackFilterParam,
  createCompanyFilterRule,
} from 'organisms/FeedbackFilterGroup/utils'
import { uploadImportCustomersCSV } from 'api'
import { toast } from 'libs/toast'
import { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import auth from 'auth'

export const customerDomain = {
  /**
   *
   * @param {object} props
   * @param {string[]=} props.names
   * @param {string[]=} props.emails
   * @param {string[]=} props.companies
   */
  generateFilterSearch(company) {
    const filterRules = [createCompanyFilterRule(company)]
    return generateFeedbackFilterParam(filterRules)
  },

  decodeFilterFromUrlParam(searchParameters) {
    const hasQuery = !R.isEmpty(searchParameters)
    if (!hasQuery) {
      return
    }
    const encodedFilter = qs.parse(searchParameters, { ignoreQueryPrefix: true }).filter

    return JSON.parse(Base64.decode(encodedFilter))
  },

  /**
   * @typedef FilterValue
   * @property {string} key
   * @property {string} filtered_values
   * @property {string=} attribute
   */

  /**
   * @typedef CustomerFilter
   * @property {FilterValue[]} and
   */

  /** @returns {CustomerFilter} */
  createCustomerFilter(filter) {
    const customerFilter = { and: [] }
    const rules = filter ? filter.rules : []
    customerFilter.and = rules.map((rule) => ({
      key: rule.field,
      filtered_values: rule.filters.map(R.prop('value')),
      comparison: rule.comparison,
      ...rule.extra,
    }))

    return customerFilter
  },

  /**
   *
   * @param {boolean} isSurveyUnsubscribed
   * @param {function} updateSubscription
   * @param {function} openEditCustomerModal
   * @param {function} openDeleteCustomerModal
   */
  getManageCustomerOptions(
    isSurveyUnsubscribed,
    updateSubscription,
    openEditCustomerModal,
    openDeleteCustomerModal
  ) {
    let options = [
      {
        text: 'Edit',
        icon: 'far fa-edit',
        onClick: openEditCustomerModal,
      },
    ]

    options = addSubscritionOption(options, isSurveyUnsubscribed, updateSubscription)
    options.push({
      text: 'Delete',
      icon: 'far fa-trash-alt',
      onClick: openDeleteCustomerModal,
      className: '!text-negative',
    })

    return options
  },

  uploadCSVFile(file, commaSeparatedTags, commaSeparatedSkippedRows, saveUserActivityLog) {
    const userInfo = auth.getUserInfoFromToken()
    const companyId = userInfo.company.id

    const formData = new FormData()
    formData.append('file', file)
    formData.append('tags', commaSeparatedTags)
    formData.append('skipped_rows', commaSeparatedSkippedRows)

    uploadImportCustomersCSV(formData)
      .then((response) => {
        toast.success("Upload in process. We'll send you an email once it's complete.")
        saveUserActivityLog({
          action: ACTION_NAME.trigger_import_customer,
          target: `com_${companyId}`,
          requestBody: {},
          statusCode: response.status,
        })
      })
      .catch((error) => {
        toast.error(
          'Oops, there was an error. Please try again or contact Simplesat support if the issue persists.'
        )
        saveUserActivityLog({
          action: ACTION_NAME.trigger_import_customer,
          target: `com_${companyId}`,
          requestBody: {},
          statusCode: error.response.status,
        })

        throw error
      })
  },
}

function addSubscritionOption(options, isSurveyUnsubscribed, updateSubscription) {
  if (isSurveyUnsubscribed) {
    return [
      ...options,
      {
        text: 'Resubscribe',
        icon: 'far fa-envelope',
        onClick: updateSubscription,
      },
    ]
  }
  return [
    ...options,
    {
      text: 'Unsubscribe',
      icon: 'far fa-ban',
      onClick: updateSubscription,
    },
  ]
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/domains/customer/index.js